let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eXELD")).then(() => parcelRequire('1sXoi'));